import DesignShowcase from "./pages/DesignShowcase";
import DemoPage from "./pages/DemoPage";
import LandingPage from "./pages/LandingPage";
import AdminAnalyticsPage from "./pages/AdminAnalyticsPage";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthPage from "./pages/AuthPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import StudioPage from "./pages/StudioPage";
import SeriesDetailPage from "./pages/SeriesDetailPage";
import SceneEditorPage from "./pages/SceneEditorPage";
import TemplatesPage from "./pages/TemplatesPage";
import SettingsPage from "./pages/SettingsPage";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/design-showcase" element={<DesignShowcase />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/studio" element={<ProtectedRoute><StudioPage /></ProtectedRoute>} />
          <Route path="/studio/:projectId" element={<ProtectedRoute><SeriesDetailPage /></ProtectedRoute>} />
          <Route path="/studio/:projectId/episodes/:episodeId/scenes/:sceneId" element={<ProtectedRoute><SceneEditorPage /></ProtectedRoute>} />
          <Route path="/templates" element={<ProtectedRoute><TemplatesPage /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
          <Route path="/admin/analytics" element={<ProtectedRoute><AdminAnalyticsPage /></ProtectedRoute>} />
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
